import { render, staticRenderFns } from "./importAndDowloadCmp.vue?vue&type=template&id=956eaf3a&scoped=true"
import script from "./importAndDowloadCmp.vue?vue&type=script&lang=js"
export * from "./importAndDowloadCmp.vue?vue&type=script&lang=js"
import style0 from "./importAndDowloadCmp.vue?vue&type=style&index=0&id=956eaf3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956eaf3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956eaf3a')) {
      api.createRecord('956eaf3a', component.options)
    } else {
      api.reload('956eaf3a', component.options)
    }
    module.hot.accept("./importAndDowloadCmp.vue?vue&type=template&id=956eaf3a&scoped=true", function () {
      api.rerender('956eaf3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/CollectionForwardingCentreHomeDeliveryCmp/importAndDowloadCmp.vue"
export default component.exports